import { ScanDataFileStatusType, ScanDataSubmissionType } from '@occc/graphql';

export const pastSubmissionsFileStatusToColorMap: Record<
  ScanDataFileStatusType,
  'success' | 'warning' | 'error'
> = {
  [ScanDataFileStatusType.Submitted]: 'success',
  [ScanDataFileStatusType.PartiallySubmitted]: 'warning',
  [ScanDataFileStatusType.NotSubmitted]: 'error',
  [ScanDataFileStatusType.SubmissionInProgress]: 'warning',
};

export const pastSubmissionsFileStatusToLabelMap: Record<ScanDataFileStatusType, string> = {
  [ScanDataFileStatusType.Submitted]: 'Submitted',
  [ScanDataFileStatusType.PartiallySubmitted]: 'Partially Submitted',
  [ScanDataFileStatusType.NotSubmitted]: 'Not Submitted',
  [ScanDataFileStatusType.SubmissionInProgress]: 'Submission In Progress',
};

export const fileStatusToColorMap: Record<
  ScanDataFileStatusType,
  'success' | 'warning' | 'error' | 'info'
> = {
  [ScanDataFileStatusType.Submitted]: 'success',
  [ScanDataFileStatusType.PartiallySubmitted]: 'warning',
  [ScanDataFileStatusType.NotSubmitted]: 'error',
  [ScanDataFileStatusType.SubmissionInProgress]: 'info',
};

export const fileStatusToLabelMap: Record<ScanDataFileStatusType, string> = {
  [ScanDataFileStatusType.Submitted]: 'Submitted',
  [ScanDataFileStatusType.PartiallySubmitted]: 'Partially Submitted',
  [ScanDataFileStatusType.NotSubmitted]: 'Not Submitted',
  [ScanDataFileStatusType.SubmissionInProgress]: 'In Progress',
};

export const pastSubmissionsTypeToLabelMap: Record<ScanDataSubmissionType, string> = {
  [ScanDataSubmissionType.Msa]: 'MSA',
  [ScanDataSubmissionType.CircanaAltria]: 'Altria',
  [ScanDataSubmissionType.CircanaRjr]: 'RJR',
};

export const scanDataFileStatusToColorMap: Record<
  ScanDataFileStatusType,
  'success' | 'warning' | 'error'
> = {
  NOT_SUBMITTED: 'error',
  PARTIALLY_SUBMITTED: 'warning',
  SUBMISSION_IN_PROGRESS: 'warning',
  SUBMITTED: 'success',
};

export const scanDataFileStatusToLabelMap: Record<ScanDataFileStatusType, string> = {
  NOT_SUBMITTED: 'Not Submitted',
  PARTIALLY_SUBMITTED: 'Partially Submitted',
  SUBMISSION_IN_PROGRESS: 'Submission In Progress',
  SUBMITTED: 'Submitted',
};

export type FileDisplayStatus =
  | 'Compiling'
  | 'Ready to Submit'
  | 'Submission in progress'
  | 'Submitted';

export const fileDisplayStatusToColorMap: Record<
  FileDisplayStatus,
  'success' | 'warning' | 'error' | 'info' | 'default'
> = {
  Compiling: 'default',
  'Ready to Submit': 'warning',
  'Submission in progress': 'warning',
  Submitted: 'success',
};

export const fileDisplayStatusToLabelMap: Record<FileDisplayStatus, string> = {
  Compiling: 'Compiling',
  'Ready to Submit': 'Ready to Submit',
  'Submission in progress': 'Submission in progress',
  Submitted: 'Submitted',
};
